export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'es', 'it'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
